import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // <---
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import "bootstrap/dist/js/bootstrap.js";
import "bootstrap/dist/css/bootstrap.css";

import "./assets/scss/main.scss";

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VCalendar from "v-calendar";
import "v-calendar/style.css";

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);

app.use(VCalendar, {});
app.component("v-select", vSelect);

app.mount("#app");
